<template>
  <form
    class="institution-form form-horizontal"
    @submit.prevent="submit()"
    v-loading="loading"
  >
    <div
      class="form-group"
      :class="{ 'has-error': errors['SEARCH_SUGGESTIONS_ACTIVE'] }"
    >
      <label for="SEARCH_SUGGESTIONS_ACTIVE" class="col-sm-2 control-label"
        >Activo</label
      >
      <div class="col-sm-10">
        <div class="checkbox">
          <label
            ><input
              type="checkbox"
              id="SEARCH_SUGGESTIONS_ACTIVE"
              v-model="data.SEARCH_SUGGESTIONS_ACTIVE"
              true-value="1"
              false-value="0"
          /></label>
        </div>
        <!--
        <input
          type="text"
          class="form-control"
          id="SEARCH_SUGGESTIONS_ACTIVE"
          v-model="data.SEARCH_SUGGESTIONS_ACTIVE"
        />
        -->
        <div
          class="help-block"
          v-for="(e, i) in errors['SEARCH_SUGGESTIONS_ACTIVE']"
          :key="i"
        >
          {{ e }}
        </div>
      </div>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors['SEARCH_SUGGESTIONS_TITLE'] }"
    >
      <label for="SEARCH_SUGGESTIONS_TITLE" class="col-sm-2 control-label"
        >Título</label
      >
      <div class="col-sm-10">
        <input
          type="text"
          class="form-control"
          id="SEARCH_SUGGESTIONS_TITLE"
          v-model="data.SEARCH_SUGGESTIONS_TITLE"
        />
        <div
          class="help-block"
          v-for="(e, i) in errors['SEARCH_SUGGESTIONS_TITLE']"
          :key="i"
        >
          {{ e }}
        </div>
      </div>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors['SEARCH_SUGGESTIONS_SIZE'] }"
    >
      <label for="SEARCH_SUGGESTIONS_SIZE" class="col-sm-2 control-label"
        >Nro de resultados</label
      >
      <div class="col-sm-10">
        <input
          type="number"
          class="form-control"
          id="SEARCH_SUGGESTIONS_SIZE"
          v-model="data.SEARCH_SUGGESTIONS_SIZE"
        />
        <div
          class="help-block"
          v-for="(e, i) in errors['SEARCH_SUGGESTIONS_SIZE']"
          :key="i"
        >
          {{ e }}
        </div>
      </div>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors['SEARCH_SUGGESTIONS_DAYS'] }"
    >
      <label for="SEARCH_SUGGESTIONS_DAYS" class="col-sm-2 control-label"
        >Perido de días</label
      >
      <div class="col-sm-10">
        <input
          type="number"
          class="form-control"
          id="SEARCH_SUGGESTIONS_DAYS"
          v-model="data.SEARCH_SUGGESTIONS_DAYS"
        />
        <div
          class="help-block"
          v-for="(e, i) in errors['SEARCH_SUGGESTIONS_DAYS']"
          :key="i"
        >
          {{ e }}
        </div>
      </div>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors['SEARCH_SUGGESTIONS_EXCLUSIONS'] }"
    >
      <label for="SEARCH_SUGGESTIONS_EXCLUSIONS" class="col-sm-2 control-label"
        >Frases a excluir</label
      >
      <div class="col-sm-10">
        <textarea
          type="text"
          class="form-control"
          id="SEARCH_SUGGESTIONS_EXCLUSIONS"
          v-model="data.SEARCH_SUGGESTIONS_EXCLUSIONS"
          placeholder="Ej: bono marzo,certificado de nacimiento,ficha protección social"
        rows="3"></textarea>
        <div class="help-block">Separar por comas (sin espacios)</div>
        <div
          class="help-block"
          v-for="(e, i) in errors['SEARCH_SUGGESTIONS_EXCLUSIONS']"
          :key="i"
        >
          {{ e }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <a class="btn btn-default" href="backend">Cancelar</a>
        <button type="button" class="btn btn-info" @click="preview()">
          Previsualizar
        </button>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </div>

    <div v-if="previewData">
      <hr />
      <h3>Previsualización</h3>
      <pre>{{ previewData }}</pre>
    </div>
  </form>
</template>
<style lang="scss" scoped>
.el-select {
  display: block;
}
</style>
<script>
import _ from "lodash";

export default {
  data: function() {
    return {
      loading: false,
      data: _.cloneDeep(this.settings),
      previewData: null,
      errors: {}
    };
  },
  props: ["settings"],

  methods: {
    preview: function() {
      this.loading = true;
      axios
        .get("backend/sugerencias/preview", {
          params: this.data
        })
        .then(response => {
          this.loading = false;
          this.previewData = response.data;
        });
    },
    submit: function() {
      var self = this;

      self.loading = true;
      axios({
        url: "backend/configuracion/lo-mas-buscado",
        method: "PUT",
        data: self.data
      })
        .then(function(response) {
          self.loading = false;
          window.location.replace(response.data.redirect);
        })
        .catch(function(error) {
          self.loading = false;
          self.errors = error.response.data.errors;
        });
    }
  }
};
</script>